/**
 * 用户基本信息
 */

import { createSlice } from "@reduxjs/toolkit";

const basic = sessionStorage.getItem("basic")
    , BasicSlice = createSlice({
        name: 'basic',
        initialState: basic ? JSON.parse(basic) : {},
        reducers: {
            setBasic(state, { payload }) {
                console.log(payload);
                const { id, name, phone, imageUrl, identityState, iosState, companyName } = payload
                state.id = id
                state.name = name
                state.imageUrl = imageUrl
                state.phone = phone
                state.identityState = identityState
                state.iosState = iosState
                state.state = payload.state
                state.companyName = companyName
                sessionStorage.setItem("basic", JSON.stringify(payload))
            }
        }
    })

// 导出action函数
export const { setBasic } = BasicSlice.actions


// 导出  reducer ， 创建store
export default BasicSlice.reducer
